import { CONSOLE_PATHS } from "@sagot/constants";
import type { ReactElement } from "react";
import { RequirePermission } from "../pages/forbidden-page";
import { AudiencesPage } from "./deploy-knowledge/audiences/audiences-page";
import { ChannelsPage } from "./deploy-knowledge/channels/channels-page";
import { KnowledgePage } from "./deploy-knowledge/knowledge/knowledge-page";
import { META_CALLBACK_PATH, MetaCallbackPage } from "./deploy-knowledge/meta-callback/meta-callback-page";
import { SourceDetailPage } from "./deploy-knowledge/source-detail/source-detail-page";
import { WebappStudioPage } from "./deploy-knowledge/webapp-studio/webapp-studio-page";
import { WidgetStudioPage } from "./deploy-knowledge/widget-studio/widget-studio-page";

/** Screens owned by the "deploy-knowledge" feature group, keyed by CONSOLE_PATHS value. */
export const deploy_knowledgeScreens: Readonly<Record<string, ReactElement>> = {
  [CONSOLE_PATHS.knowledge]: (
    <RequirePermission permission="knowledge.view" mode="agent">
      <KnowledgePage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.sourceDetail]: (
    <RequirePermission permission="knowledge.view">
      <SourceDetailPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.widgetStudio]: (
    <RequirePermission permission="widget.view" mode="agent">
      <WidgetStudioPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.webappStudio]: (
    <RequirePermission permission="widget.view" mode="agent">
      <WebappStudioPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.channels]: (
    <RequirePermission permission="channels.view" mode="agent">
      <ChannelsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.audiences]: (
    <RequirePermission permission="audiences.view">
      <AudiencesPage />
    </RequirePermission>
  ),
  /**
   * DEC-024 Meta OAuth redirect. Lives outside `/w/:ws` (Meta redirects to one fixed URL), so the
   * route table must mount it under `RequireAuth` (not inside the workspace children) — see report.
   */
  [META_CALLBACK_PATH]: <MetaCallbackPage />,
};
